import { memo } from 'react';

// @mui material components
import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';

// Material Dashboard 2 PRO React example components
import Layout from './Layout';
import Navbar from './Navbar';
import Header from './Header';

import Footer from 'examples/Footer';

function AaroLayout({ children }) {
    return (
        <Layout>
            <MDBox width="calc(100% - 48px)" position="absolute" top="1.75rem">
                <Navbar light absolute />
            </MDBox>
            <Header />
            <MDBox pb={3}>
                <MDBox mt={5}>
                    <Grid container spacing={3}>
                        <Grid size={12}>{children}</Grid>
                    </Grid>
                </MDBox>
            </MDBox>
            <Footer />
        </Layout>
    );
}

export default memo(AaroLayout);
